<template>
  <div>
    <div class="bulk-tag-uploader">
      <span>
        <button
          class="btn btn-default btn-sm input-group-btn__icon"
          :disabled="!bulkTagFileId"
          @click="showBulkTagSearch"
        >
          <i class="fa fa-search p-r-0" />
        </button>
      </span>

      <SearchableDropdown
        v-model="bulkTagFileId"
        :config="dropdownConfig"
        class="m-0 bulk-tag-uploader__select"
        @change="onExistingFileSelect"
      >
        <template
          v-slot:option-data="{option}"
        >
          {{ option.name }}
          <i class="m-l-5 f-s-11 m-t-2 text-muted">{{ option.tagCount }} tags</i>
        </template>

        <template
          v-slot:selected-option-data="{option}"
        >
          <span
            style="overflow: hidden;text-overflow: ellipsis;"
            :title="`${option.name} - ${option.tagCount} tags`"
          >
            {{ option.name }}
            <i class="m-l-5 f-s-11 m-t-2 text-muted">{{ option.tagCount }} tags</i>
          </span>
        </template>
      </SearchableDropdown>

      <span>
        <file-upload
          ref="uploadButton"
          v-model="bulkTagFile"
          extensions="txt"
          accept="text/plain"
          name="bulkTagFileUpload"
          :disabled="showFileLoader"
          class="btn btn-default btn-sm input-group-btn__icon clickable file-uploads--custom"
          @input-file="onNewFileUpload"
        >
          <i
            v-if="!showFileLoader"
            class="fa fa-cloud-upload fa-lg p-r-0"
          />
          
          <Loader
            v-if="showFileLoader"
            custom-class="loader-container m-t-4 size-sm loader-container--no-margin"
          />
        </file-upload>
      </span>
    </div>

    <div
      v-if="showSearchInput"
      class="phone-validation-icon-container"
    >
      <input
        v-model.trim="searchTag"
        type="search"
        class="form-control"
        placeholder="Search tag in selected bulk upload"
        @input="searchTagInput"
      >

      <Loader
        v-if="showLoader"
        custom-class="loader-container size-sm"
      />

      <i
        v-if="searchTagExists === false"
        class="fa fa-times text-danger phone-validation-icon"
      />
      <i
        v-if="searchTagExists"
        class="fa fa-check text-success phone-validation-icon"
      />
    </div>
  </div>
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import debounce from 'lodash/debounce';
import { mapActions, mapGetters, mapState } from 'vuex';

const bulkTagDropdownCommonConfig = {
  reduce: option => option.id,
  label: 'name',
  placeholder: 'Upload tags'
};

export default {
  name: 'BulkTagUploader',
  components: {
    SearchableDropdown,
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    bulkTagList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      bulkTagFile: [],
      searchTag: '',
      showSearchInput: false,
    };
  },
  computed: {
    ...mapState({
      accountId: 'currentAccountId'
    }),

    ...mapState('callFlows', [
      'searchTagExists',
      'newUploadedBulkTagId'
    ]),

    ...mapGetters('callFlows', [
      'isLoading'
    ]),

    showLoader() {
      return this.isLoading('checkTagExistsInUploadedBulkTags');
    },

    showFileLoader() {
      return this.isLoading('uploadBulkTagFile');
    },

    dropdownConfig() {
      return {
        options: this.bulkTagList,
        ...bulkTagDropdownCommonConfig
      };
    },

    bulkTagFileId: {
      get() {
        return this.value;
      },
      set(newFileId) {
        this.$emit('input', newFileId);
        this.$emit('change', newFileId);
      }
    }
  },
  methods: {
    ...mapActions('callFlows', [
      'checkTagExistsInUploadedBulkTags',
      'uploadBulkTagFile'
    ]),

    async onNewFileUpload() {
      await this.uploadBulkTagFile(this.bulkTagFile?.[0]?.file);

      if (this.newUploadedBulkTagId) {
        this.bulkTagFileId = this.newUploadedBulkTagId;
      }
    },
    
    onExistingFileSelect(bulkTagFile) {
      this.$emit('change', (bulkTagFile && bulkTagFile.id) || '');
    },

    showBulkTagSearch() {
      this.showSearchInput = !this.showSearchInput;
    },

    searchTagInput: debounce(async function() {
      await this.checkTagExistsInUploadedBulkTags({ searchTag: this.searchTag, selectedBulkTagId: this.bulkTagFileId});
    }, 500)
  }
};
</script>

<style lang="scss">
.file-uploads--custom {
  display: flex !important;
  align-items: center;

  &.file-uploads-html5 {
    label {
      cursor: pointer;
      width: 0;
      height: 0;
    }
  }
}

.bulk-tag-uploader {
  display: flex;
}

.bulk-tag-uploader__select {
  min-width: 0;
  flex-basis: 100%;
}
</style>  